import { gql } from '@apollo/client';

export const fetchDemographicAudienceInsightSettings = gql`
  query getDemographicInsightSettings {
    fetchDemographicInsightSettings {
      success
      ... on FetchDemographicInsightSettingsSuccess {
        settings {
          contactProperty
          presentationMode
        }
        maxDemographicInsightSettingsForProject
      }
    }
  }
`;

export const fetchBehavioralAudienceInsightSettings = gql`
  query getBehavioralInsightSettings {
    fetchBehavioralInsightSettings {
      success
      ... on FetchBehavioralInsightSettingsSuccess {
        settings {
          eventName
          presentationMode
          dataType
        }
        maxBehavioralInsightSettingsForProject
      }
    }
  }
`;
